import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, InputGroup, Well, Panel, Nav, Tab, NavItem, Glyphicon, MenuItem, DropdownButton } from 'react-bootstrap';
import { withFormik } from 'formik';
import { browserHistory } from 'react-router';
import $ from 'jquery';
import _ from 'lodash';

import SendEmailForm, { isEmailIntegrated } from './common/SendEmailForm';
import SendSmsForm, { isSmsIntegrated } from './common/SendSmsForm';
import LoadingProgressBar from './common/LoadingProgressBar';
import ConfirmDialog from './common/ConfirmDialog';
import LoadClientDialog, { searchClients } from './common/LoadClientDialog';
import Button from './common/Button';
import Select from './common/Select';
import Radio from './common/Radio';
import ServerError from './common/ServerError';
import FormEditor, { prepareFieldsForSaving } from './common/FormEditor';
import FormField from './common/FormField';
import EditTypesDialog from './common/EditTypesDialog';
import DynamicFields,
       { filterDynamicFieldsMap, 
         getDynamicFieldsMapFromConfig, 
         wrapEmployeeForSelect } from './common/DynamicFields';

import { onWorkflowFormEditorSave } from '../../client/formEditor';
import { isEmptyObject, validateRequired } from '../validators/formValidators';

import { intakeFormSaveAction } from '../actions/formActions';
import { caseEditIdAction,
         caseSavingNeededAction,
         casesRefreshNeededAction,
         caseSetServerError,
         caseSubmitPublicAction,
         caseGetPublicData,
         caseSetServerSuccess,
         caseSetCurrentAction,
         casePublicIntakeFormEnable,
         caseIsPublicIntakeFormEnabled } from '../actions/caseActions';

import { clientsRefreshNeededAction } from '../actions/clientActions';
import { defaultWorkflow } from '../helpers/config';
import {
    getUrlVars,
    getTodayDateTZ,
    getObjectValue,
    isDemoAccount,
    getSectionsFromFields,
    replaceFieldsInConfig,
    getFormEditorSuggestionFieldsArrayFromConfig, 
    getFullName} from './../helpers/utils';

import { validateDynamicForm } from './../validators/dynamicFormValidator';
import { isEmptyString } from './../validators/formValidators';
import { errorBackgroundColor } from '../helpers/colors';
import { privateFormFieldColor } from './../helpers/colors';
import { getCountry } from '../helpers/internationalization';


const valuesToCase = (values) => {
    const data = { intake: {}, client: {} };
    _.forOwn(values, (value, key) => {
        const tableSplitIndex = key.indexOf('_');
        const table = key.substring(0, tableSplitIndex);
        const name = key.substring(tableSplitIndex + 1);
        if (!isEmptyString(table)) {
            data[table][name] = value;
        }
    });

    return data;
};

class IntakeForm extends PureComponent {
    constructor(props) {
        super(props);
        this.formEditorSave = this.formEditorSave.bind(this);
        this.formEditorCancel = this.formEditorCancel.bind(this);
        this.getSectionForms = this.getSectionForms.bind(this);
        this.renderFormEditor = this.renderFormEditor.bind(this);
        this.getExpandedForms = this.getExpandedForms.bind(this);
        this.getForms = this.getForms.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.publicEmailIntakeForm = this.publicEmailIntakeForm.bind(this);
        this.publicSmsIntakeForm = this.publicSmsIntakeForm.bind(this);
        this.publicIntakeFormDisable = this.publicIntakeFormDisable.bind(this);
        this.saveCallbackCount = 0;
        this.getClientSuggestions = this.getClientSuggestions.bind(this);
        this.modifyClientFieldsMap = this.modifyClientFieldsMap.bind(this);
        this.allClients = undefined;
        this.state = {
            loadingPublic: false,
            sections: undefined,
            sectionIndex: 0,
            editedWorkflowDialogOpen: false,
            editedConfig: undefined,
            editedCaseType: undefined,
            caseManagerSelected: undefined,
            clientSuggestions: [],
            clientHeaders: [],
            dedupeDialogOpen: false,
            duplicateClientAllowed: false,
        };
    }

    componentDidMount() {
        let publicCssUrl;
        if (this.props.publicIntake) {
            if (this.props.publicIntakeHash && !this.props.currentConfig && !this.state.loadingPublic) {
                this.setState({loadingPublic: true});
                this.props.dispatch(caseGetPublicData(this.props.publicIntakeHash, this.props.publicMatterHash))
                    .then((result) => {
                        if (!result) {
                            this.props.dispatch(caseSetServerError('Cannot access intake form.'));
                            return;
                        }
    
                        this.setState({ loadingPublic: false });
                    })
                    .catch((error) => {
                        console.error(new Error().stack, error);
                        this.props.dispatch(caseSetServerError(error));
                    });
            }

            publicCssUrl = this.props.query['css'];
            if (publicCssUrl) {
                $("html, body, form").css('display', 'none');
                $("#mainCss").remove();
                $.ajax({
                    url: publicCssUrl,
                    dataType: 'text',
                    success: (data) => {
                        let styleElement = $(document.createElement('style'));
                        styleElement.attr({type: 'text/css', id: 'mainCss'});
                        styleElement.html(data);
                        $('head').prepend(styleElement);
                    }
                });

                $(window).load(() => {
                    $("html, body, form").fadeIn(800);
                });
            }

        } else if (this.props.values.id) {
            this.props.dispatch(caseIsPublicIntakeFormEnabled(this.props.values.id));
        }

        if (this.props.dialogDedupeClient) {
            this.getClientSuggestions();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.caseType !== nextProps.caseType) {
            nextProps.setFieldValue('intake_CaseType', nextProps.caseType);
        }

        const caseManagerSelected = this.state.caseManagerSelected;
        if (!nextProps.values['intake_AssignedTo']) {
            if (caseManagerSelected !== undefined) {
                nextProps.setFieldValue('intake_AssignedTo', caseManagerSelected);
            } else if (nextProps.isNew && nextProps.loggedIn) {
                nextProps.setFieldValue('intake_AssignedTo', nextProps.loggedIn.id + '');
            }
        }

        const intakeSections = getSectionsFromFields(nextProps.intakeFieldsMap, 'Case', nextProps.errors ) || [];
        const clientSections = getSectionsFromFields(nextProps.clientFieldsMap, 'Client', nextProps.errors ) || [];
        const sections = [ ...clientSections, ...intakeSections ];
        let sectionIndex = this.state.sectionIndex;
        if (sectionIndex > sections.length) {
            sectionIndex = 0;
        }

        let editedConfig = this.state.editedConfig;
        let editedCaseType = this.state.editedCaseType;
        if (nextProps.renderFormEditor) {
            if (editedCaseType === undefined && nextProps.caseType) {
                editedCaseType = nextProps.caseType;
            }

            if (nextProps.currentConfig && !_.isEqual(nextProps.currentConfig, editedConfig)) {
                editedConfig = _.cloneDeep(nextProps.currentConfig);
            }
        }

        this.setState({
            sections,
            sectionIndex,
            editedConfig,
            editedCaseType,
        });
    }

    async getClientSuggestions() {
        if (!this.allClients) {
            this.allClients = [];
            const result = await searchClients({query: '', filter: undefined});
            if (result.error) {
                this.props.dispatch(caseSetServerError('Cannot load existing clients to search for duplicates.'));
                return;
            }

            this.allClients = result.clients;
            this.setState({clientHeaders: result.headers});
        }

        const firstName = (this.props.values['client_FirstName'] || '').trim().toLowerCase();
        const lastName = (this.props.values['client_LastName'] || '').trim().toLowerCase();
        const clientSuggestions = [];
        for (let i = 0; i < this.allClients.length; i++) {
            const client = this.allClients[i].client;
            if ((client['FirstName'] || '').trim().toLowerCase() === firstName &&
                (client['LastName'] || '').trim().toLowerCase() === lastName)
            {
                clientSuggestions.push(this.allClients[i]);
            }
        }

        this.setState({clientSuggestions});
        return clientSuggestions;
    }

    async submitForm() {
        if (this.state.duplicateClientAllowed || !this.props.dialogDedupeClient || this.props.values['client_id']) {
            this.props.submitForm();
            return;
        }

        const duplicateClients = await this.getClientSuggestions();
        if (duplicateClients.length > 0) {
            this.setState({dedupeDialogOpen: true});
            return;
        }

        this.props.submitForm();
    }

    formEditorSave() {
        const workflow = this.state.editedConfig.workflow;
        for (let i = 0; i < workflow.length; i++) {
            const intakeTables = workflow[i].tables.find(v => v.table === 'intake');
            const clientTables = workflow[i].tables.find(v => v.table === 'client');
            const intakeFields = (intakeTables && intakeTables.fields) || [];
            const clientFields = (clientTables && clientTables.fields) || [];
            prepareFieldsForSaving(intakeFields, 'intake.');
            prepareFieldsForSaving(clientFields, 'client.');
        }

        onWorkflowFormEditorSave(this.props.dispatch, workflow, () => this.props.onFormEditorSave());
    }

    formEditorCancel() {
        this.props.onFormEditorCancel();
    }

    modifyClientFieldsMap(clientFieldsMap) {
        if (!this.props.dialogDedupeClient) {
            return;
        }

        ['client_FirstName', 'client_LastName'].forEach(name => {
            let choiceField = clientFieldsMap.find(c => c.name === name);
            if (choiceField) {
                choiceField.type = 'TextInput';
                choiceField.props['onBlur'] = async() => {
                    const duplicateClients = await this.getClientSuggestions();
                    if (duplicateClients.length > 0) {
                        this.setState({dedupeDialogOpen: true});
                    }
                };
            }
        });
    }

    getSectionForms() {
        const sections = this.state.sections || [];
        const sectionIndex = this.state.sectionIndex || 0;
        const fieldsMap = sectionIndex < sections.length ? sections[sectionIndex].fields : [];
        this.modifyClientFieldsMap(fieldsMap);
        return (
        <Tab.Container defaultActiveKey={0}
                       activeKey={sectionIndex}
                       onSelect={index => {this.setState({ sectionIndex: index })}}>
            <div>
            <Row style={{ marginLeft: -5 }}>
                <Col xs={12} md={3}>
                    <Nav bsStyle="pills">
                        {sections.map((section, index) => {
                            return (<NavItem key={index} eventKey={index} style={{ width: '100%', backgroundColor: section.errors.length > 0 ? errorBackgroundColor : undefined }}>{section['label']}</NavItem>);
                        })}
                    </Nav>
                </Col>
                <Col xs={12} md={6}>
                    <Tab.Content animation>
                    <Row>
                        <Col xs={12}>
                        <Panel style={{ marginLeft: -29 }}>
                            <Tab.Pane eventKey={sectionIndex}>
                                <DynamicFields
                                    {...this.props}
                                    values={this.props.values}
                                    errors={this.props.errors}
                                    touched={this.props.touched}
                                    handleBlur={this.props.handleBlur}
                                    handleChange={this.props.handleChange}
                                    fieldsMap={fieldsMap}
                                    submitting={this.props.isSubmitting}
                                    loading={this.props.loadingCurrent}
                                    currentConfig={this.props.currentConfig}
                                    publicIntake={this.props.publicIntake}
                                    country={getCountry(this.props.loggedIn)}
                                />
                            </Tab.Pane>
                        </Panel>
                        </Col>
                    </Row>
                    </Tab.Content>
                </Col>
            </Row>
            </div>
        </Tab.Container>);
    }

    getExpandedForms() {
        const columnWidth = this.props.tasksToggled ? 12 : 6;
        const intakeFieldsMap = this.props.intakeFieldsMap;
        const clientFieldsMap = [...this.props.clientFieldsMap];
        let clientPanel = '';
        this.modifyClientFieldsMap(clientFieldsMap);       
        if (clientFieldsMap && Object.keys(clientFieldsMap).length > 0) {
            clientPanel = (
                <div id="clientPanelDiv">
                <Row>
                    <Col xs={12}>
                        <DynamicFields
                            {...this.props}
                            values={this.props.values}
                            errors={this.props.errors}
                            touched={this.props.touched}
                            handleBlur={this.props.handleBlur}
                            handleChange={this.props.handleChange}
                            fieldsMap={clientFieldsMap}
                            submitting={this.props.isSubmitting}
                            loading={this.props.loadingCurrent}
                            currentConfig={this.props.currentConfig}
                            publicIntake={this.props.publicIntake}
                            country={getCountry(this.props.loggedIn)}
                        />
                    </Col>
                </Row>
                </div>
            );

            clientPanel = (
                <Col md={columnWidth} xs={12}>
                {clientPanel}        
                </Col>
            );
        }

        let casePanel = '';
        if (intakeFieldsMap && Object.keys(intakeFieldsMap).length > 0) {
            casePanel = (
                <div id="casePanelDiv">
                <Row>
                    <Col xs={12}>
                        <DynamicFields
                            {...this.props}
                            values={this.props.values}
                            errors={this.props.errors}
                            touched={this.props.touched}
                            handleBlur={this.props.handleBlur}
                            handleChange={this.props.handleChange}
                            fieldsMap={intakeFieldsMap}
                            submitting={this.props.isSubmitting}
                            loading={this.props.loadingCurrent}
                            currentConfig={this.props.currentConfig}
                            publicIntake={this.props.publicIntake}
                            country={getCountry(this.props.loggedIn)}
                        />
                    </Col>
                </Row>
                </div>
            );

            casePanel = (
                <Col md={columnWidth} xs={12}>
                {casePanel}        
                </Col>
            );
        }

        return  (
            <Row className="row-display-flex">
            {clientPanel}
            {casePanel}
            </Row>);
    }
    
    getForms() {
        if (this.props.values['SectionView'] === 'Separator') {
            return this.getSectionForms();
        }
        
        return this.getExpandedForms();
    }

    publicEmailIntakeForm() {
        if (!this.props.currentCase) {
            return;
        } 
        
        this.props.dispatch(casePublicIntakeFormEnable(this.props.currentCase.id, true))
                    .then(result => {
                        this.setState({ emailIntakeFormDialog: true });
                    }).catch(error => {
                        console.error(new Error().stack, error);
                        this.props.dispatch(caseSetServerError(error));
                    });
    }

    publicSmsIntakeForm() {
        if (!this.props.currentCase) {
            return;
        } 
        
        this.props.dispatch(casePublicIntakeFormEnable(this.props.currentCase.id, true))
                    .then(result => {
                        this.setState({ smsIntakeFormDialog: true });
                    }).catch(error => {
                        console.error(new Error().stack, error);
                        this.props.dispatch(caseSetServerError(error));
                    });
    }

    publicIntakeFormDisable() {
        if (!this.props.currentCase) {
            return;
        } 
        
        this.props.dispatch(casePublicIntakeFormEnable(this.props.currentCase.id, false))
                  .catch(error => {
                      console.error(new Error().stack, error);
                      this.props.dispatch(caseSetServerError(error));
                  });
    }

    renderFormEditor() {
        if (!this.state.editedConfig || !this.state.editedCaseType) {
            return (<div />);
        }

        const caseType = this.state.editedCaseType;
        const currentConfig = this.state.editedConfig;
        const fieldMaps = getFieldMaps(currentConfig, caseType, true);
        const intakeFieldsMap = fieldMaps.intakeFieldsMap;
        const intakeFieldsSuggestions = fieldMaps.intakeFieldsSuggestions;
        let hasError = false;
        if (intakeFieldsMap) {
            hasError = intakeFieldsMap.reduce((error, curr) => error || !!curr.error, false);
        }

        let caseTypes = undefined;
        if (!isEmptyObject(currentConfig)) {
            caseTypes = currentConfig.workflow.map((item) => {
                return item.type;
            });
        }

        const isSubmitting = this.props.isSubmitting;

        return (
            <ConfirmDialog
                title="Edit Case Type Forms"
                cancel={this.formEditorCancel}
                confirm={this.formEditorSave}
                open={this.props.formEditorOpen}
                disabled={hasError}
                error={hasError || ''}
            >
            <Row>
                <Col xs={12}>
                    <FormField>
                        <InputGroup>
                        <Select field={{
                                    onChange: evt => this.setState({ editedCaseType: evt.target.value}),
                                    onBlur: () => {},           
                                    value: caseType,
                                }}
                                disabled={typeof(caseTypes) === 'undefined' || isSubmitting}
                                loading={typeof(caseTypes) === 'undefined'}
                                options={caseTypes}
                        />
                        <InputGroup.Button style={{ paddingTop: '5px' }}>
                        <Button onClick={() => {
                                    this.setState({ editedWorkflowDialogOpen: true });
                                }}
                                disabled={isSubmitting}
                                icon="cog"
                                bsStyle="link"
                                iconStyle={{ height: '20px', paddingTop: '2px' }}
                                tooltip="Configure case types"
                                tooltipPosition="left"
                        />
                        </InputGroup.Button>
                        </InputGroup>
                    </FormField>
                </Col>
                <Col xs={12}><Well>Edit the fields contained on the form describing type of case you are working with.</Well></Col>
                <Col xs={12}><legend>Fields:</legend></Col>
            </Row>
            <Row>
                <Col xs={12}>
                <FormEditor fields={intakeFieldsMap}
                            suggestedFields={intakeFieldsSuggestions}
                            placeholderNamePrefix="intake."
                            disallowedPlaceholderNames={['id', 'CaseType', 'AssignedTo', 'intake.AssignedTo', 'intake.id', 'intake.CaseType', 'intake.CreatedDate']}
                            renderSaveButton={false}
                            renderCancelButton={false}
                            onChange={(fields) => { 
                                const editedConfig = replaceFieldsInConfig(currentConfig, caseType, 'intake', fields, 'workflow');
                                this.setState({ editedConfig });
                            }}
                />
                </Col>
            </Row>

            <EditTypesDialog types={currentConfig.workflow}
                                defaultType={defaultWorkflow}
                                open={this.state.editedWorkflowDialogOpen}
                                onClose={() => {
                                    this.setState({editedWorkflowDialogOpen: false});
                                }}
                                label="Edit Case Types"
                                typeLabel="Selected Case Type"
                                modificationDisabled={(types, selectedIndex) => {
                                    let modificationDisabled = true;
                                    if (selectedIndex >= 0 && this.props.workflowStat && types[selectedIndex]) {
                                        let selectedType = types[selectedIndex].type;
                                        if (!this.props.workflowStat[selectedType] || this.props.workflowStat[selectedType] == 0) {
                                            modificationDisabled = false;
                                        }
                                    }

                                    return modificationDisabled;
                                }}
                                saveAction={workflow => {
                                    const editedConfig = currentConfig;
                                    editedConfig.workflow = _.cloneDeep(workflow);
                                    this.setState({editedConfig});
                                }}
            />
            </ConfirmDialog>
        );
    }

    render() {
        const {
            currentConfig,
            caseType,
            intakeFieldsMap,
            isSubmitting,
            loadingCurrent,
            handleBlur,
            handleChange,
            touched,
            errors,
            values,
            employees = [],
            loggedIn,
            setFieldValue,
        } = this.props;
        
        let {
            currentCase
        } = this.props;

        let caseManagerOptions = [];
        caseManagerOptions = caseManagerOptions.concat(employees);
        caseManagerOptions.unshift({label: '', value: -1});

        if (this.props.renderFormEditor) {
            return this.renderFormEditor();
        }

        let caseTypes = undefined;
        if (!isEmptyObject(currentConfig)) {
            caseTypes = currentConfig.workflow.map((item) => {
                return item.type;
            });
        }

        let dialogs = '';
        let switchViews;
        let shareViews = (
            <Button style={{width: 150, float: 'right'}}
                    bsStyle="primary"
                    label={this.props.publicIntake ? 'Submit' : 'Save'}
                    loading={isSubmitting && !this.props.publicIntake}
                    disabled={isSubmitting}
                    loadingLabel={this.props.publicIntake ? 'Submitting ...' : 'Saving ...'}
                    icon={this.props.publicIntake ? '' : 'floppy-disk'}
                    id="submitButton"
                    onClick={this.submitForm}
            />);

        if (this.props.publicIntake) {
            dialogs = (
                <div>
                <ConfirmDialog
                    title="Success"
                    text={this.props.serverSuccess}
                    open={this.props.serverSuccess !== undefined}
                    confirm={() => this.props.dispatch(caseSetServerSuccess(undefined))}
                    confirmLabel="Ok"
                    confirmButtonIcon="none"
                />
                <ServerError error={this.props.serverError}
                             style="popup"
                             close={() => { this.props.dispatch(caseSetServerError(undefined)); }}
                />
                </div>
            );
            
        } else {
            switchViews = (
                <Radio field={{
                            name: 'SectionView',
                            onChange: handleChange,
                            onBlur: handleBlur,
                            error: errors['SectionView'],
                            touched: touched['SectionView'],
                            value: values['SectionView'],
                        }}
                        style={{ float: 'left', marginLeft: 15 }}
                        name="SectionView"
                        options={[
                            {
                                value: 'Expanded',
                                label: 'Show Expanded',
                            },
                            {
                                value: 'Separator',
                                label: 'Show In Sections',
                            }]}
                />);

                const editEmailTemplates = [];
                if (currentConfig && currentConfig["publicIntakeEmailTemplates"] && currentCase) {
                    const template = currentConfig["publicIntakeEmailTemplates"].find(v => v.type === currentCase['CaseType']);
                    if (template) {
                        editEmailTemplates.push({...template});
                    }
                }

                const editSmsTemplates = [];
                if (currentConfig && currentConfig["publicIntakeSmsTemplates"] && currentCase) {
                    const template = currentConfig["publicIntakeSmsTemplates"].find(v => v.type === currentCase['CaseType']);
                    if (template) {
                        editSmsTemplates.push({...template});
                    }
                }

                if (this.props.currentCase && this.props.currentCase.id) {
                    shareViews = (
                        <div>
                        <DropdownButton title={(<span><Glyphicon glyph='share-alt' /> Share Form </span>)}
                                                        bsStyle='link'
                                                        data-hj-whitelist
                                                        style={{ width: 130, float: 'right', marginRight: __IS_MOBILE__ ? 0 : '15px' }}
                                        dropup
                        >
                        <MenuItem data-hj-whitelist onClick={this.publicEmailIntakeForm} disabled={!isEmailIntegrated(loggedIn)}>Email Intake Form ...</MenuItem>
                        <MenuItem data-hj-whitelist onClick={this.publicSmsIntakeForm} disabled={!isSmsIntegrated(loggedIn)}>SMS Intake Form ...</MenuItem>
                        <MenuItem divider />
                        <MenuItem data-hj-whitelist disabled={!currentCase.publicIntakeEnabled} onClick={this.publicIntakeFormDisable}>Disable Intake Form Sharing</MenuItem>
                        </DropdownButton>
                        {shareViews}
                        <SendEmailForm showAsDialog
                                    initialTemplate={editEmailTemplates && {...editEmailTemplates[0]}}
                                    templatesFieldName="publicIntakeEmailTemplates"
                                    enableAddTemplate={false}
                                    enableEditTemplate={false}
                                    renderTemplateLoad={false}
                                    renderEmailSection
                                    renderEmailButton
                                    disableCaseFilesAutoload
                                    renderAttachmentField={false}
                                    onEmailSent={() => this.setState({ emailIntakeFormDialog: false })}
                                    cancel={() => this.setState({ emailIntakeFormDialog: false })}
                                    open={this.state.emailIntakeFormDialog}
                                    title="Email Intake Form"
                        />
                        <SendSmsForm showAsDialog
                                    templates={editSmsTemplates}
                                    initialTemplate={editSmsTemplates && {...editSmsTemplates[0]}}
                                    templatesFieldName="publicIntakeSmsTemplates"
                                    enableAddTemplate={false}
                                    enableEditTemplate={false}
                                    renderTemplateLoad={false}
                                    onSmsSent={() => this.setState({ smsIntakeFormDialog: false })}
                                    cancel={() => this.setState({ smsIntakeFormDialog: false })}
                                    open={this.state.smsIntakeFormDialog}
                                    title="SMS Intake Form"
                        />
                        </div>);
                    }
        }

        const intakeForm = this.getForms();
        const saveButton = (
            <div>
            {switchViews}
            {shareViews}
            </div>
        );

        let result = (
            <form style={{
                      overflowX: this.props.publicIntake && 'hidden'
                  }}
            >
                {loadingCurrent && (
                <Row>
                    <Col xs={12}>
                        <LoadingProgressBar loading={loadingCurrent} />
                    </Col>
                </Row>)}
                {(!this.props.publicIntake || !this.props.publicIntakeWorkflow) &&
                <Row>
                    {!this.props.publicIntake && (
                    <Col xs={12} md={6}>
                        <Select field={{
                                    onChange: (evt) => {
                                        setFieldValue('intake_AssignedTo', evt.target.value);
                                        this.setState({ caseManagerSelected: evt.target.value });
                                    },
                                    onBlur: () => {},           
                                    value: values['intake_AssignedTo'],
                                }}
                                label={(<b style={{color: privateFormFieldColor}}>Case Manager</b>)}
                                disabled={isSubmitting}
                                options={caseManagerOptions.map(wrapEmployeeForSelect)}
                        />
                    </Col>)}
                    <Col xs={12} md={6}>
                        <Select field={{
                                    onChange: evt => {
                                        const caseData = valuesToCase(values);
                                        caseData['CaseType'] = evt.target.value;
                                        caseData.intake['CaseType'] = evt.target.value;
                                        this.props.dispatch(caseSetCurrentAction(caseData))
                                    },
                                    onBlur: () => {},           
                                    value: caseType,
                                }}
                                label={(<b>Case Type</b>)}
                                disabled={typeof(caseTypes) === 'undefined' || isSubmitting}
                                loading={typeof(caseTypes) === 'undefined'}
                                options={caseTypes}
                        />
                    </Col>
                </Row>}
                {intakeForm}
                {!this.props.showAsDialog &&  (
                <Row>
                    <Col xs={12} style={{marginTop: 20}}>
                    {saveButton}
                    </Col>
                </Row>)}
                {dialogs}
            </form>
        );

        if (this.props.publicIntake && !this.props.query['embedded'] && this.props.loggedIn) {
           result = <Panel header={this.props.loggedIn['CompanyName'] + ' - ' + caseType}>{result}</Panel>;
        }

        if (!this.props.showAsDialog) {
            return result;
        }

        let hasErrors = false;
        Object.keys(this.props.errors).map(error => {
            hasErrors = hasErrors || this.props.touched[error];
        });

        let title = this.props.dialogTitle;
        if (this.props.dialogDedupeClient) {
            if (this.props.values['client_id']) {
                const name = {
                    FirstName: this.props.values['client_FirstName'],
                    MiddleName: this.props.values['client_MiddleName'],
                    LastName: this.props.values['client_LastName'],
                };

                title = `${title} for '${getFullName(name)}'`;
            } else {
                title = title + ' - New Client';
            }
        }

        return (
            <ConfirmDialog title={title}
                           cancel={this.props.dialogCancel}
                           confirm={this.props.dialogConfirm}
                           confirmButton={saveButton}
                           open={this.props.dialogOpen}
                           size={this.props.dialogSize}
                           error={hasErrors || ''}
            >
            {result}
            {this.props.dialogDedupeClient &&
                <LoadClientDialog
                    title='Duplicate Client Found!'
                    open={this.state.dedupeDialogOpen}
                    cancel={() => {
                        this.setState({
                            dedupeDialogOpen: false,
                            duplicateClientAllowed: true,
                        });
                    }}
                    action={
                        <Button
                            onClick={() => {
                                this.setState({
                                    dedupeDialogOpen: false,
                                    duplicateClientAllowed: true,
                                });
                            }}
                            icon="remove"
                            label="Ignore"
                        />
                    }
                    showSearchForm={false}
                    selectRow={(index, client) => {
                        const values = {...this.props.values};
                        client = client.client;
                        for (const [key, value] of Object.entries(client)) {
                            values['client_' + key] = value;
                        }

                        this.props.setValues(values);
                        this.setState({dedupeDialogOpen: false});
                    }}
                    data={{
                        rows: this.state.clientSuggestions,
                        headers: this.state.clientHeaders
                    }}
                />
            }
            </ConfirmDialog>
        );
    }
}

IntakeForm.propTypes = {
    loadingCurrent: PropTypes.bool.isRequired,
    publicIntake: PropTypes.bool,
    afterSaveAction: PropTypes.func,
    renderFormEditor: PropTypes.bool,
    customSaveButtonRender: PropTypes.func,
    isNew: PropTypes.bool,

    // dialog
    showAsDialog: PropTypes.bool,
    dialogTitle: PropTypes.string,
    dialogCancel: PropTypes.func,
    dialogConfirm: PropTypes.func,
    dialogOpen: PropTypes.bool,
    dialogSize: PropTypes.string,
    dialogDedupeClient: PropTypes.bool,
};

const getFieldMaps = (config, caseType, renderFormEditor) => {
    const tableNamePrefix = renderFormEditor ? '.' : '_';
    let intakeFieldsMapUnfiltered = getDynamicFieldsMapFromConfig(config, caseType, 'intake', 'intake' + tableNamePrefix);
    const intakeFieldsSuggestions = getFormEditorSuggestionFieldsArrayFromConfig(config, 'workflow', true, (type, table, field) => type !== caseType && (!table || table === 'intake') && (!field || !['Hidden', 'Separator'].includes(field.type)));
    const intakeFieldsMap = [];
    if (intakeFieldsMapUnfiltered) {
        for (let i = 0; i < intakeFieldsMapUnfiltered.length; i++) {
            const field = intakeFieldsMapUnfiltered[i];
            if ('CaseType' === field.type) {
                continue;
            }

            if (field.type === 'Separator' && !renderFormEditor) {
                if (i + 1 >= intakeFieldsMapUnfiltered.length) {
                    continue;
                }

                const nextField = intakeFieldsMapUnfiltered[i + 1];
                if (['CaseType', 'Separator'].includes(nextField.type)) {
                    continue;
                }
            }

            intakeFieldsMap.push(field);
        }
    }

    const clientFieldsMapUnfiltered = getDynamicFieldsMapFromConfig(config, caseType, 'client', 'client' + tableNamePrefix);
    const clientFieldsMap = [];
    if (clientFieldsMapUnfiltered) {
        for (let i = 0; i < clientFieldsMapUnfiltered.length; i++) {
            const field = clientFieldsMapUnfiltered[i];
            if (field.type === 'Separator') {
                if (i + 1 >= clientFieldsMapUnfiltered.length) {
                    continue;
                }

                const nextField = clientFieldsMapUnfiltered[i + 1];
                if ('Separator' === nextField.type) {
                    continue;
                }
            }

            clientFieldsMap.push(field);
        }
    }

    return { clientFieldsMap, intakeFieldsMap, intakeFieldsSuggestions };
};

const mapStateToProps = (state, ownProps) => {
    let currentCase = state.cases.current;
    let currentConfig = state.user.config;
    let caseType;
    const workflow = currentConfig && currentConfig.workflow;
    if (workflow) {
        if (currentCase['CaseType'] && workflow.find(v => v.type === currentCase['CaseType'])) {
            caseType = currentCase['CaseType'];
        } else if (workflow.length > 0) {
            caseType = workflow[0].type;
        }
    }

    let intakeHash;
    let intakeWorkflow;
    let matterHash;
    if (ownProps.publicIntake) {
        const path = state.routing.locationBeforeTransitions.pathname;
        const start = path.indexOf('/', 1) + 1;
        const end = path.indexOf('/', start);
        if (end == -1) {
            intakeHash = path.substring(start);
            intakeWorkflow = state.routing.locationBeforeTransitions.query.q;
        } else if (end == path.length - 1 && state.routing.locationBeforeTransitions.query.q) {
            intakeHash = path.substring(start, end);
            intakeWorkflow = state.routing.locationBeforeTransitions.query.q;
        } else {
            intakeHash = path.substring(start, end);
            matterHash = path.substring(end + 1);
            intakeWorkflow = caseType;
        }

        if (workflow && workflow.find((value) => {return value.type === intakeWorkflow})) {
            caseType = intakeWorkflow;
        } else {
            intakeWorkflow = undefined;
        }
    }

    const fieldMaps = getFieldMaps(state.user.config, caseType, ownProps.renderFormEditor);
    const clientFieldsMap = fieldMaps.clientFieldsMap;
    const intakeFieldsMap = fieldMaps.intakeFieldsMap;
    const intakeFields =  {};
    if (intakeFieldsMap) {
        for (let i = 0; i < intakeFieldsMap.length; i++) {
            intakeFields[intakeFieldsMap[i].name] = '';
        }
    }

    if (currentCase && currentCase.intake) {
        _.forOwn(currentCase.intake, (value, key) => {
            key.replace('intake.', '');
            if (!key.startsWith('intake_')) {
                key = `intake_${key}`;
            }

            intakeFields[key] = value; 
        });
    }

    const clientFields = {};
    if (clientFieldsMap) {
        for (let i = 0; i < clientFieldsMap.length; i++) {
            clientFields[clientFieldsMap[i].name] = '';
        }
    }

    if (currentCase && currentCase.client) {
        _.forOwn(currentCase.client, (value, key) => {
            key.replace('client.', '');
            if (!key.startsWith('client_')) {
                key = `client_${key}`;
            }

            clientFields[key] = value; 
        });
    }

    const loggedIn = state.user.loggedIn;
    const initialValues = {
        'intake_CaseType': caseType,
        ...intakeFields,
        'client_id': getObjectValue(currentCase, 'client_id'),
        ...clientFields
    };

    if (!initialValues['client_CreatedDate']) {
        initialValues['client_CreatedDate'] = getTodayDateTZ(loggedIn, true, true);
    }

    if (!initialValues['intake_CreatedDate']) {
        initialValues['intake_CreatedDate'] = getTodayDateTZ(loggedIn, true, true);
    }

    _.forEach([...intakeFieldsMap, ...clientFieldsMap], (value) => { 
        const name = value.name.replace('client.', 'client_').replace('intake.', 'intake_');
        initialValues[name] = initialValues[name]; 
    });

    const workflowStat = (state.user.stats && state.user.stats.workflow);
    const query = getUrlVars();
    if (!ownProps.publicIntake &&
        ((intakeFieldsMap && intakeFieldsMap.find(v => v.type === 'Separator')) ||
        (clientFieldsMap && clientFieldsMap.find(v => v.type === 'Separator')))) {
            
        initialValues['SectionView'] = 'Separator';
    } else {
        initialValues['SectionView'] = 'Expanded';
    }

    return {
        serverError: state.cases._serverError,
        serverSuccess: state.cases._serverSuccess,
        loadingCurrent: state.cases.loadingCurrent,
        savingNeeded: state.cases.savingNeeded,
        currentCase,
        caseType,
        currentConfig,
        workflow,
        workflowStat,
        intakeFieldsMap, // for dynamic form validation
        clientFieldsMap, // for dynamic form validation
        intakeFieldsSuggestions: fieldMaps.intakeFieldsSuggestions,
        publicIntakeHash: intakeHash,
        publicMatterHash: matterHash,
        publicIntakeWorkflow: intakeWorkflow,
        initialValues,
        tasksToggled: state.user.tasksToggled,
        query,
        loggedIn,
        employees: state.user.employees,
    };
};

const validateIntakeForm = (data, props) => {
    const errors = { ...validateDynamicForm(data, filterDynamicFieldsMap(props.intakeFieldsMap, props.publicIntake)),
               ...validateRequired(data['intake_CaseType'], 'intake_CaseType'),
               ...validateDynamicForm(data, filterDynamicFieldsMap(props.clientFieldsMap, props.publicIntake))
    };

    return errors;
};

const handleSubmit = async (values, formikBag) => {
    const data = valuesToCase(values);
    if (formikBag.props.publicIntake) {
        data['$IntakeHash$'] = formikBag.props.publicIntakeHash;
        data.intake['CreatedDate'] = 'server';
        data.client['CreatedDate'] = 'server';

        try {
            const result = await formikBag.props.dispatch(caseSubmitPublicAction(data, formikBag.props.publicMatterHash));
            if (!result) {
                formikBag.props.dispatch(caseSetServerError('Intake submission failed!'));
                console.error('Intake submission failed!');
                return;
            }

            formikBag.resetForm();
            formikBag.props.dispatch(caseSetServerSuccess('Thank you for submitting your information. We will contact you shortly.'));

        } catch (error) {
            formikBag.props.dispatch(caseSetServerError(error));
            console.error(new Error().stack, error);
        }
        
        return;
    }

    let newClient = true;
    if (formikBag.props.currentCase) {
        data.id = formikBag.props.currentCase.id;
        if (!data.client.id) {
            data.client.id = getObjectValue(formikBag.props.currentCase, 'client.id');
        }
        if (data.client.id) {
            newClient = false;
        }
    }

    try {
        const result = await formikBag.props.dispatch(intakeFormSaveAction(data));
        if (result) {
            const savedCase = result.data.currentCase;
            formikBag.props.dispatch(caseSavingNeededAction(false));
            formikBag.props.dispatch(casesRefreshNeededAction(true));
            const id = parseInt(savedCase.id, 10);
            formikBag.props.dispatch(caseEditIdAction(id));
            if (newClient) {
                formikBag.props.dispatch(clientsRefreshNeededAction(true, true));
            }

            browserHistory.push(`/case/edit/intake/${savedCase.id}`);
            if (formikBag.props.afterSaveAction) {
                formikBag.props.afterSaveAction();
            }
        }

    } catch (error) {
        console.error(new Error().stack, error); 
        formikBag.props.dispatch(caseSetServerError(error));   
    }

    formikBag.setSubmitting(false);
};

const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    validate: validateIntakeForm,
    handleSubmit,
    enableReinitialize: true,
};

export default connect(mapStateToProps)(withFormik(formikWrapper)(IntakeForm));

export const EditIntakeForm = connect(mapStateToProps)(withFormik(formikWrapper)(IntakeForm));
